// Angular
import { Injectable } from "@angular/core";
// RxJS
import { BehaviorSubject } from "rxjs";

@Injectable()
export class AtylDialogService {
	private atylDialog: any;
	private currentState: BehaviorSubject<boolean> = new BehaviorSubject(false);

	// Public properties
	constructor() {
		this.atylDialog = new atylDialog({
			type: "loader",
			placement: "bottom left",
			message: "Chargement ...",
		});
	}

	show() {
		this.currentState.next(true);
		this.atylDialog.show();
	}

	hide() {
		this.currentState.next(false);
		this.atylDialog.hide();
	}

	checkIsShown() {
		return this.currentState.value;
	}
}
